import { Injectable } from '@angular/core'
import { HttpClearwaterTransactionsService } from '@helios/common-api'
import {
  clearCreateEditTransActions,
  inactivateSession,
  setActiveSession,
  setCreateEditTransActions,
} from '@helios/state-management'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { of } from 'rxjs'
import { catchError, map, switchMap } from 'rxjs/operators'

@Injectable()
export class AvailableActionsEffects {
  fetchOnSessionActivation$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setActiveSession),
      switchMap(() =>
        this.httpCwTransactionsService.getAvailableActions().pipe(
          map(actions => setCreateEditTransActions({ actions })),
          catchError(err => {
            console.error('Failed to fetch available actions', err)
            return of(clearCreateEditTransActions())
          }),
        ),
      ),
    ),
  )

  clearOnSessionDeactivation$ = createEffect(() =>
    this.actions$.pipe(
      ofType(inactivateSession),
      map(() => clearCreateEditTransActions()),
    ),
  )

  constructor(
    private readonly actions$: Actions,
    private readonly httpCwTransactionsService: HttpClearwaterTransactionsService,
  ) {}
}
